<template>
  <div>
    <div class="text-right">
      <va-button color="info" @click="show = true"
        >Создать доп услуги</va-button
      >
    </div>

    <va-modal v-model="show" size="large" hide-default-actions>
      <form @submit.prevent="submitHandler">
        <div class="mb-3">
          <va-input v-model="form.name" class="mb-0" placeholder="Название" />
          <div
            v-if="!$v.form.name.required && $v.form.name.$error"
            class="error-message"
          >
            Обязательно для заполнения
          </div>
        </div>
        <div class="mb-3">
          <va-input
            v-model="form.price"
            class="mb-0"
            type="number"
            placeholder="Цена"
          />
          <div
            v-if="!$v.form.price.required && $v.form.price.$error"
            class="error-message"
          >
            Обязательно для заполнения
          </div>
        </div>
        <div class="mb-3">
          <va-input
            v-model="form.qty"
            type="number"
            class="mb-0"
            placeholder="Кол-во"
          />
          <div
            v-if="!$v.form.qty.required && $v.form.qty.$error"
            class="error-message"
          >
            Обязательно для заполнения
          </div>
        </div>

        <div class="text-center">
          <va-button @click.prevent="show = false">Отменить</va-button>
          <va-button type="submit">Сохранить</va-button>
        </div>
      </form>
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      show: false,
      form: {
        name: "",
        price: "",
        qty: "",
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      price: {
        required,
      },
      qty: {
        required,
      },
    },
  },
  methods: {
    async submitHandler() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      } else {
        const { name, price, qty } = this.form;
        if (qty > 0 && price > 0) {
          try {
            const data = {
              name,
              price: Number(price),
              qty: Number(qty),
            };
            api.post("/admin/additional-products", data);
            for (const key in this.form) {
              this.form[key] = "";
            }
            this.show = false;
            this.$emit("neeFetch");
          } catch (error) {
            return error;
          }
        }
      }
    },
  },
};
</script>
